// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#333","menuActiveText":"#ee2e2e","subMenuActiveText":"#333","menuBg":"#fff","menuHover":"#ebebeb","subMenuBg":"#f4f4f4","subMenuHover":"#ebebeb","sideBarWidth":"210px"};